module.exports = __webpack_public_path__ + "static/media/double-plan-consult2.2c118324.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/double-plan-consult2.jpg
// module id = 1974
// module chunks = 6